export default class OBCategoryToColorConverter
{

    constructor()
    {

    }

    convert(category)
    {

        switch(category)
            {

                case "Wall":
                    return 0xffffff;
                case "Floor":
                    return 0xffffff;
                case "Pipe":
                    return 0x00a38b;
                case "Duct":
                    return 0x00b3c8;
                case "DuctAcc":
                    return 0x3E7B93;
                case "Cabletray":
                    return 0xC75D8B;
                case "Cabletray":
                    return 0xC75D8B;
                default:
                    return 0xffffff;


            }
        

    }




}